import React from "react";
import styled from "styled-components";
import { Colors, TextFont } from "../../config";

const ImgHeaderSubheader = ({ imgSrc, header, subheader }) => {
  return (
    <ImgHeaderSubheaderWrapper>
      {imgSrc && <ImgResp src={imgSrc} alt="login-pic" />}
      <HeaderSubWrapper isGapNeeded={imgSrc}>
        <TextFont
          fontColor={Colors.white}
          fontSize="2.5rem"
          fontWeight="500"
          maxWidth="500px"
          respFontSize="1.6rem"
        >
          {header}
        </TextFont>
        <TextFont
          fontSize="1.375rem"
          fontColor={Colors.white}
          fontWeight="300"
          maxWidth="500px"
          respFontSize="1rem"
        >
          {subheader}
        </TextFont>
      </HeaderSubWrapper>
    </ImgHeaderSubheaderWrapper>
  );
};

export default ImgHeaderSubheader;

const ImgHeaderSubheaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;
const HeaderSubWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  padding-top: ${(props) => props.isGapNeeded && "1rem"};
`;
const ImgResp = styled.img`
  height: auto;
  max-width: 100%;
  @media only screen and (max-height: 780px) {
    width: 40%;
  }
  @media only screen and (max-width: 500px) {
    width: 60%;
  }
`;
